import { render, staticRenderFns } from "./ISelect.vue?vue&type=template&id=613972b9&scoped=true&"
import script from "./ISelect.vue?vue&type=script&lang=js&"
export * from "./ISelect.vue?vue&type=script&lang=js&"
import style0 from "./ISelect.vue?vue&type=style&index=0&id=613972b9&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613972b9",
  null
  
)

export default component.exports